@if (messageContent) {
  <div class="slice-image-container">
    <!-- Image information -->
    <div class="viz-header">
      <div class="viz-title">{{ image_information.job_name }}</div>
      <div class="viz-meta">
        Iteration:
        {{ image_information.iteration }}
        {{ image_information.dimension && " | " + image_information.dimension }}
        {{
        image_information.slice_number &&
        "(" + image_information.slice_number + ")"
        }}
      </div>
    </div>
    <nz-divider class="viz-divider"></nz-divider>
    <nz-spin [nzSpinning]="loading">
      <div class="viz-layout">
        <div class="shrink-container" [class.shrinkHide]="hide_settings">
          <div class="content-wrapper">
            <div class="viz-panel-toolbar">
              <button nz-button (click)="hide_settings = true" nzSize="small" class="viz-panel-fold">
                <span nz-icon nzType="menu-fold" nzTheme="outline"></span>
              </button>
              <button nz-button nzType="primary" (click)="get_image(true)" class="viz-panel-update">
                Update
              </button>
            </div>
            <nz-input-group class="legacy-input-styling viz-field">
              <label class="viz-field-label">Model Type</label>
              <nz-select class="viz-field-control" [(ngModel)]="image_plot_parameters.type"
                (ngModelChange)="onChangeModelType($event)">
                @for (model_type of ['Vp', 'vdiff', 'DenChange','RTM','RWI_Perturb', 'add_perturb vdiff', 'Total_Vp_Update']; track model_type) {
                  <nz-option [nzValue]="model_type" [nzLabel]="model_type"></nz-option>
                }
              </nz-select>
            </nz-input-group>
            @if (image_plot_parameters.type === 'Total_Vp_Update') {
              <nz-input-group class="legacy-input-styling viz-field">
                <label class="viz-field-label">VP Ref</label>
                <nz-input-number class="viz-field-control" [(ngModel)]="image_plot_parameters.vp_ref"
                  [nzMin]="0" [nzMax]="image_information.iteration" [nzStep]="1"></nz-input-number>
              </nz-input-group>
            }
            @if (centered_model_range) {
              <nz-input-group class="legacy-input-styling viz-field">
                <label class="viz-field-label">Min/Max</label>
                <nz-input-number class="viz-field-control" [ngModel]="image_plot_parameters.max_val"
                (ngModelChange)="onChangeCenteredModelRange($event)"></nz-input-number>
              </nz-input-group>
            }
            @if (!centered_model_range) {
              <nz-input-group class="legacy-input-styling viz-field">
                <label class="viz-field-label">Min</label>
                <nz-input-number class="viz-field-control" [(ngModel)]="image_plot_parameters.min_val"></nz-input-number>
              </nz-input-group>
              <nz-input-group class="legacy-input-styling viz-field">
                <label class="viz-field-label">Max</label>
                <nz-input-number class="viz-field-control" [(ngModel)]="image_plot_parameters.max_val"></nz-input-number>
              </nz-input-group>
            }
            @if (crop_available) {
              <nz-divider nzText="Crop (m)" nzOrientation="right" class="viz-divider"></nz-divider>
              <div>
                <label nz-checkbox class="viz-checkbox" [(ngModel)]="crop_params.enabled">Crop image?</label>
              </div>
              <nz-input-group class="viz-field-row" nzCompact>
                <nz-input-group class="legacy-input-styling viz-field viz-field--flush">
                  <label class="viz-field-label">X min</label>
                  <nz-input-number class="viz-field-control" [(ngModel)]="crop_params.x_min"
                    [nzDisabled]="!crop_params.enabled" [nzMin]="0" [nzStep]="100"></nz-input-number>
                </nz-input-group>
                <nz-input-group class="legacy-input-styling viz-field viz-field--flush">
                  <label class="viz-field-label">X max</label>
                  <nz-input-number class="viz-field-control" [(ngModel)]="crop_params.x_max"
                    [nzDisabled]="!crop_params.enabled" [nzMin]="0" [nzStep]="100"></nz-input-number>
                </nz-input-group>
              </nz-input-group>
              <nz-input-group class="viz-field-row" nzCompact>
                <nz-input-group class="legacy-input-styling viz-field viz-field--flush">
                  <label class="viz-field-label">Y min</label>
                  <nz-input-number class="viz-field-control" [(ngModel)]="crop_params.y_min"
                    [nzDisabled]="!crop_params.enabled" [nzMin]="0" [nzStep]="100"></nz-input-number>
                </nz-input-group>
                <nz-input-group class="legacy-input-styling viz-field viz-field--flush">
                  <label class="viz-field-label">Y max</label>
                  <nz-input-number class="viz-field-control" [(ngModel)]="crop_params.y_max"
                    [nzDisabled]="!crop_params.enabled" [nzMin]="0" [nzStep]="100"></nz-input-number>
                </nz-input-group>
              </nz-input-group>
              <button nz-button nzSize="small" (click)="apply_crop()" class="viz-crop-apply">
                Apply crop
              </button>
            }
            @if (
              image_information.dimension == 'depth' ||
              image_information.model_grid.is_2d
              ) {
              <nz-divider nzText="Shots" nzOrientation="right" class="viz-divider"></nz-divider>
              <nz-spin [nzSpinning]="loading_shot">
                <div>
                  <label nz-checkbox class="viz-checkbox" [(ngModel)]="show_shots"
                  (ngModelChange)="onChangeShowShots()">Show Shots?</label>
                </div>
                <div>
                  <label nz-checkbox class="viz-checkbox" [nzDisabled]="!show_shots"
                    [(ngModel)]="hide_shots_without_trace_fit"
                    (ngModelChange)="apply_shot_trace_fit_filter()">Hide shots without trace fit?</label>
                </div>
                <nz-input-group class="viz-field-row" nzCompact>
                  <nz-input-group class="legacy-input-styling viz-field viz-field--flush">
                    <label class="viz-field-label">Trace Color Min</label>
                    <input [disabled]="!show_shots" (blur)="update_shot_colors()" type="number" nz-input
                      [(ngModel)]="trace_color_min" />
                  </nz-input-group>
                  <nz-input-group class="legacy-input-styling viz-field viz-field--flush">
                    <label class="viz-field-label">Trace Color Max</label>
                    <input [disabled]="!show_shots" (blur)="update_shot_colors()" type="number" nz-input
                      [(ngModel)]="trace_color_max" />
                  </nz-input-group>
                </nz-input-group>
                <div class="trace-color-scale">
                  <span class="scale-label scale-min">{{ trace_color_min }}</span>
                  <span class="scale-label scale-max">{{ trace_color_max }}</span>
                </div>
                <div class="shot-radius-control">
                  Shot Radius
                  <nz-slider [nzDisabled]="!show_shots" [nzMin]="1" [nzMax]="20" [(ngModel)]="shot_radius"
                  (ngModelChange)="onChangeShotRadius()"></nz-slider>
                </div>
              </nz-spin>
            }
          </div>
        </div>
        <div id="image-box" #sliceImageContainer class="viz-image-box">
          <!-- the calc height is to regulate with the 50px of the coloarbar, and 10px gap.
          Since its a SVG element, its sort of complicated to make it dynamically size correctly hence the
          sort of hacky solution -->
          <button nz-button [nzGhost]="true" (click)="add_image_to_flipper()" class="add-image-to-flipper-button"
            nzSize="small" nz-tooltip nzTooltipTitle="Add to image flipper">
            <span nz-icon nzType="select" nzTheme="outline"></span>
          </button>
          @if (hide_settings) {
            <button nz-button [nzGhost]="true" (click)="hide_settings = false"
              class="open-image-settings-button" nzSize="small">
              <span nz-icon nzType="menu-unfold" nzTheme="outline"></span>
            </button>
          }
          <div #chartTooltip class="chart-tooltip"></div>
        </div>
        @if (image_colorbar_url) {
          <div id="colorbar-box" class="viz-colorbar">
            <span class="viz-colorbar-label">{{
              image_plot_parameters.min_val
            }}</span>
            <img [src]="image_colorbar_url" class="viz-colorbar-img" />
            <span class="viz-colorbar-label">{{
              image_plot_parameters.max_val
            }}</span>
          </div>
        }
      </div>
    </nz-spin>
  </div>
}
